import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "./api/axios";
import headerImage from "../../assets/images/game-supergirls/TamhaRak_Poster.jpg";
import ProfileHeader from "../header/ProfileHeader";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";

export default function Rewards() {
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId") ?? "";
  const [items, setItems] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get(`/game-rewards/my?lineId=${userId}`);
    setItems(res.data);
  };

  // ฟังก์ชันแปลง timestamp
  const formatDate = (dt) => {
    if (!dt) return "-";
    const d = new Date(dt);
    return d.toLocaleString("th-TH", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleGoBack = () => {
    navigate("/game/supergirls");
  };

  return (
    <div className="w-full flex flex-col gap-y-4">
      <div className="h-screen flex flex-col bg-secondary-background-gray">
        <ProfileWithBackButtonHeader onClick={handleGoBack} />

        <div className="flex-grow overflow-y-auto">
          <div className="reward-container">
            <img
              src={headerImage}
              alt="ตามหารักที่เธอลืม"
              className="quiz-header-image"
            />

            <div className="question-card-wrapper">
              <div className="question-card">
                <h2 className="text-lg font-bold mb-4">ประวัติรางวัล</h2>

                {items.length === 0 && (
                  <div className="text-gray-500 text-center">
                    คุณยังไม่มีประวัติการได้รับรางวัล
                  </div>
                )}
                {/* 
                {items.map((r) => (
                  <div
                    key={r.id}
                    className="border p-3 rounded mb-3 bg-white shadow-sm"
                  >
                    <div className="flex justify-between">
                      <span className="font-semibold text-blue-600">
                        🎁 {r.point_value} Point
                      </span>
                      <span
                        className={`px-2 py-1 rounded text-white text-xs ${
                          r.status === "ได้รับพอยต์แล้ว"
                            ? "bg-green-600"
                            : r.status === "รอรับพอยต์"
                            ? "bg-yellow-600"
                            : r.status === "รอผูกบิ๊กพอยต์"
                            ? "bg-orange-500"
                            : r.status === "หมดอายุ"
                            ? "bg-gray-500"
                            : "bg-red-600"
                        }`}
                      >
                        {r.status}
                      </span>
                    </div> */}

                {items.map((r) => (
                  <div
                    key={r.id}
                    className="border p-3 rounded mb-3 bg-white shadow-sm"
                  >
                    <div className="flex justify-between items-center">
                      <span className="font-semibold text-blue-600">
                        🎁 {r.point_value} Point
                      </span>
                      <span
                        className={`px-2 py-1 rounded text-white text-xs ${
                          // ✅ เช็คจากค่าภาษาอังกฤษ (ค่าจริงจาก DB)
                          r.status === "granted"
                            ? "bg-green-600"
                            : r.status === "pending_grant"
                            ? "bg-yellow-500"
                            : r.status === "pending_bind_bigpoint"
                            ? "bg-orange-500"
                            : r.status === "expired"
                            ? "bg-gray-500"
                            : "bg-red-600"
                        }`}
                      >
                        {/* ✅ แสดงผลเป็นภาษาไทย */}
                        {r.status === "granted"
                          ? "ได้รับพอยต์แล้ว"
                          : r.status === "pending_grant"
                          ? "รอรับพอยต์"
                          : r.status === "pending_bind_bigpoint"
                          ? "รอเชื่อมต่อบัญชีบิ๊กพอยต์"
                          : r.status === "expired"
                          ? "หมดอายุ"
                          : "ไม่สำเร็จ"}
                      </span>
                    </div>

                    <div className="mt-2 text-sm text-gray-700">
                      <div>📅 วันที่ร่วมสนุก: {formatDate(r.reserved_at)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
